import { render, staticRenderFns } from "./import-records.vue?vue&type=template&id=a8f9b8b4"
import script from "./import-records.vue?vue&type=script&lang=js"
export * from "./import-records.vue?vue&type=script&lang=js"
import style0 from "./import-records.vue?vue&type=style&index=0&id=a8f9b8b4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports